import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { badgeRendition, badgePosition, badgeRenditionEnum, badgePositionEnum } from '../badge.component';

export interface IBadgeDynamicClasses {
  rendition: badgeRendition;
  position: badgePosition;
}

@Directive({
  selector: '[appBadgeDynamicClasses]'
})
export class BadgeDynamicClassesDirective implements AfterViewInit {
  @Input() appBadgeDynamicClasses: IBadgeDynamicClasses;

  constructor(private _elRef: ElementRef, private _renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    this._processClasses();
  }

  private _processClasses() {
    const {rendition, position} = this.appBadgeDynamicClasses;

    if (rendition && rendition in badgeRenditionEnum) {
      this._renderer.addClass(this._elRef.nativeElement, `badge--${rendition}`);
    }
    if (position && position in badgePositionEnum) {
      this._renderer.addClass(this._elRef.nativeElement, `badge--position`);
      this._renderer.addClass(this._elRef.nativeElement, `badge--position__${position}`);
    }
  }
}
